/*=========================================================================================
  File Name: moduleMessagerieMutations.js
  Description: Messagerie Module Mutations
==========================================================================================*/

export default {
  SET_CONVERSATIONS(state, list) {
    state.conversations = list;
  },
  SET_ACTIVE(state, id) {
    state.activeConversationId = id;
  },
  SET_MESSAGES(state, list) {
    state.messages = list;
  },
  ADD_MESSAGE(state, message) {
    state.messages.push(message);
  },
  SET_UNREAD(state, unread) {
    state.unread = unread;
  },
  SET_CONTACTABLE_COUNT(state, count) {
    state.contactableClientsCount = count;
  },
  SET_CONVERSATION_UNREAD(state, { id, count }) {
    const conversation = state.conversations.find(c => c.id === id);
    if (conversation) conversation.unreadCount = count;
  },
  SET_LOADING(state, value) {
    state.isLoading = value;
  },
  SET_SENDING(state, value) {
    state.isSending = value;
  },
  SET_POLL_TIMER(state, timer) {
    state.pollTimer = timer;
  },
};
